<template>
  <form class="position-relative">
    <loader :loading="loading" block />

    <v-card v-if="!loading">
      <v-card-title class="headline grey lighten-2 mb-4 justify-center" primary-title>
        Просмотр параметра {{ name }}
      </v-card-title>
      <v-card-text>
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">Время</th>
                <th class="text-left">Значения</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, idx) in data" :key="`${item.date}-${idx}`">
                <td>{{ item.date }}</td>
                <td>{{ item.value }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>
      <v-card-title class="headline grey lighten-2 mb-4 justify-center" primary-title>
        Значения параметра за все время
      </v-card-title>
      <ParameterDynamicChart v-if="series && series.datasets.length" :data="series" :options="options" />
      <v-divider class="mt-4"></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="close">Закрыть</v-btn>
      </v-card-actions>
    </v-card>
  </form>
</template>

<script>
import Loader from "@/components/Loader";
import { CustomerService } from "@/services/api/customer.service";

import ParameterDynamicChart from "./ParameterDynamicChart.vue";
export default {
  name: "ModalParameterInfo",

  components: { Loader, ParameterDynamicChart },

  props: {
    parameter: {
      type: Object,
    },
    name: {
      type: String,
    },
  },

  data: () => ({
    loading: false,
    data: [],
    series: { datasets: [], labels: [] },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          display: false,
          labels: {
            color: "rgb(255, 99, 132)",
          },
        },
      },
    },
  }),

  computed: {
    customerId() {
      return this.$store.state.customer.id;
    },
  },

  async mounted() {
    this.loading = true;

    try {
      this.data = await CustomerService.getParameterMeasurementsForDay(this.customerId, this.parameter.pid, this.parameter.date);
      console.log(this.data);
      const series = await CustomerService.getParameterMeasurementsForChart(this.customerId, this.parameter.pid);
      this.series.labels = series.map(s => s.med_param_dt.split(" ")[0]);
      this.series.datasets = [
        {
          label: this.name,
          backgroundColor: "#bebebe",
          data: series.map(s => Number(s.med_param_value)),
        },
      ];
    } catch (e) {
      console.log(`e =>`, e);
      //
    }
    this.loading = false;
  },

  methods: {
    /**
     * Закрытия модального окна
     */
    close() {
      this.$emit("close");
      this.$emit("submit");
    },
  },
};
</script>
